export const getColors = (state) => state.form.colors;
export const getTypes = (state) => state.form.types;
export const getHeights = (state) => state.form.heights;
export const getPanels = (state) => state.form.panelsList;
export const getPosts = (state) => state.form.postsList;
export const getCornerPosts = (state) => state.form.cornerPostsList;
export const getAccessories = (state) => state.form.accessoryList;
export const getCornerPostAccessories = (state) => state.form.cornerPostAccessoryList;
export const getCornerAccessories = (state) => state.form.cornerAccessoryList;
export const getAddedProducts = (state) => state.form.addedProducts;
export const getTreeStructureSettings = (state) => state.form.treeStructureSettings;
export const getInputDataToSend = (state) => state.form.inputDataToSend;
export const getNecessaryProductsQuantity = (state) => state.form.necessaryProductsQuantity;
